// The closed 3-channel vocabulary a launcher waterfall cell / playbooks sequence
// sends over. One schema for launcher (`wire-schemas.ts`) and playbooks
// (`schemas.ts`), so the two cannot drift. Zod only, no sibling imports.
import { z } from 'zod';

export const ChannelSchema = z.enum(['gong_engage', 'inflection', 'slack_copilot']);
export type Channel = z.infer<typeof ChannelSchema>;
